<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card card-vampire">
          <div class="card-header">
            <h5 class="card-title mb-0">Redefinir Senha</h5>
          </div>
          <div class="card-body">
            <form @submit.prevent="resetPassword">
              <div class="mb-3">
                <label for="newPassword" class="form-label">Nova Senha</label>
                <input type="password" class="form-control" id="newPassword" v-model="newPassword" @input="validatePassword" required>
              </div>
              <div class="mb-3">
                <label for="confirmPassword" class="form-label">Confirmar Nova Senha</label>
                <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" required>
              </div>
              <div class="password-strength mb-3">
                <div :class="{ 'text-success': passwordCriteria.length }"><i class="bi" :class="passwordCriteria.length ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> Mínimo 8 caracteres</div>
                <div :class="{ 'text-success': passwordCriteria.uppercase }"><i class="bi" :class="passwordCriteria.uppercase ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> Letra maiúscula</div>
                <div :class="{ 'text-success': passwordCriteria.lowercase }"><i class="bi" :class="passwordCriteria.lowercase ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> Letra minúscula</div>
                <div :class="{ 'text-success': passwordCriteria.number }"><i class="bi" :class="passwordCriteria.number ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> Número</div>
                <div :class="{ 'text-success': passwordCriteria.special }"><i class="bi" :class="passwordCriteria.special ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> Caractere especial</div>
              </div>
              <div v-if="passwordsMismatch" class="alert alert-danger">As senhas não coincidem.</div>
              <div v-if="message" class="alert alert-info">{{ message }}</div>
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <div class="d-grid">
                <button type="submit" class="btn btn-vampire" :disabled="!isFormValid || isLoading">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Redefinir Senha
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
import { validatePassword, isPasswordSecure } from '../utils/validation';

export default {
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      token: '',
      message: '',
      error: '',
      isLoading: false,
      passwordCriteria: {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      },
    };
  },
  computed: {
    isFormValid() {
      return (
        this.newPassword === this.confirmPassword &&
        isPasswordSecure(this.passwordCriteria)
      );
    },
    passwordsMismatch() {
      return this.confirmPassword && this.newPassword !== this.confirmPassword;
    },
  },
  methods: {
    validatePassword() {
      this.passwordCriteria = validatePassword(this.newPassword);
    },
    async resetPassword() {
      if (!this.isFormValid) {
        return;
      }

      this.isLoading = true;
      this.message = '';
      this.error = '';

      try {
        const response = await api.post('/auth/reset-password', {
          token: this.token,
          newPassword: this.newPassword,
        });
        this.message = response.data.message;
      } catch (err) {
        this.error = err.response?.data?.error || 'Ocorreu um erro ao redefinir sua senha.';
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.token = this.$route.params.token;
  },
};
</script>

<style scoped>
.card-vampire {
  background-color: var(--vampire-dark-gray);
  border: 1px solid var(--vampire-red);
  color: var(--vampire-light-text);
}

.password-strength div {
  transition: color 0.3s;
}

.text-success {
  color: #28a745 !important;
}
</style>
